import Contract from './Contract';
import EceptionWithObject from '../exceptions/EceptionWithObject';
import AssetComponent from "../../plugins/assetComponent/models/AssetComponent";

export default class ContractAggregate {
  constructor(
    hasManualCharts,
    contract,
    assetComponents
  ) {
    this.hasManualCharts = hasManualCharts;
    if (!(contract instanceof Contract)) throw new EceptionWithObject(
      "Canot create ContractAggregate if contract is not an instance of Contract class.", contract);
    this.contract = contract;
    this.assetComponents = assetComponents; // can be emtpy array
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create ContractAggregate from data if data is null.");

    const contract = Contract.createFromData(data.contract);

    let assetComponents = [];
    for (let i = 0; i < data.assetComponents.length; i++) {
      const element = data.assetComponents[i];
      assetComponents.push(AssetComponent.createFromData(element));
    }
    return new ContractAggregate(data.hasManualCharts, contract, assetComponents)
  }

  static createNew() {
    const contract = Contract.createNew();
    const hasManualCharts = false;
    return new ContractAggregate(
      hasManualCharts,
      contract,
      []
    );
  }


  static convertToSendData(item) {
    let assetComponents = [];

    for (let i = 0; i < item.assetComponents.length; i++) {
      let element = item.assetComponents[i];
      assetComponents.push(element);
    }

    return {
      hasManualCharts: item.hasManualCharts,
      contract: {
        idInDB: item.contract.idInDB,
        externalId: item.contract.externalId,
        currencyCode: "RUB",
        date: item.contract.date,
        number: item.contract.number,
        lesseeCounterpartyId: item.contract.lesseeCounterpartyId,
        lessorCounterpartyIds: item.contract.lessorCounterpartyIds,
        status: item.contract.status,
        turnoverPercentage: item.contract.turnoverPercentage,
        responsible: item.contract.responsible,
        revenues: item.contract.revenues,
        type: "Contract",
        commentary: item.contract.commentary,
        externalLink: item.contract.externalLink,
        externalLinkName: item.contract.externalLinkName,
        prolongationType: item.contract.prolongationType,
        createDate: item.contract.createDate,
      },
      assetComponents,
    };
  }
}
